// Console SPA — 简易 hash 路由（取代 TanStack Router）。

import { useEffect, useState } from 'react';

export type RouteName = 'login' | 'sites' | 'dashboard' | 'logs';

const ROUTES: Record<string, RouteName> = {
  '#/login': 'login',
  '#/sites': 'sites',
  '#/dashboard': 'dashboard',
  '#/logs': 'logs',
};

function parseHash(): RouteName {
  const h = (typeof window === 'undefined' ? '' : window.location.hash) || '#/sites';
  return ROUTES[h] ?? 'sites';
}

export function useHashRoute(): RouteName {
  const [route, setRoute] = useState<RouteName>(parseHash);
  useEffect(() => {
    const onChange = (): void => setRoute(parseHash());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
}

export function navigate(name: RouteName): void {
  window.location.hash = `#/${name}`;
}
